import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { Proposal } from "../../../definitions/proposal";
import { OrderProposalService } from "../../../services/api/order-proposal.service";
import { OrderProposalActions } from "../../actions/order-proposal.actions";
import { FailState } from "../../models/fail-state";
import { ProposalsState } from "../../models/proposals-state";
import { AppState } from "../../reducers";
import { ProposalSelectors } from "../../selectors/proposal.selectors";
import { StoreKeys } from "../../store-keys";

@Injectable()
export class ProposalGetEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(OrderProposalActions.proposalDetails.get),
			withLatestFrom(this.store.select(ProposalSelectors.proposalsWithDetails)),
			switchMap(([action, state]) => {
				const proposal = this.getStoreValue(action, state);
				return proposal
					? of(OrderProposalActions.proposalDetails.getSuccess(proposal))
					: of(OrderProposalActions.proposalDetails.getApi({ id: action.id }));
			})
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(OrderProposalActions.proposalDetails.getApi),
			switchMap((action) =>
				this.orderProposalService.getProposalById(action.id).pipe(
					map((proposal) => OrderProposalActions.proposalDetails.getSuccess(proposal)),
					catchError((error) =>
						of(OrderProposalActions.proposalDetails.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private orderProposalService: OrderProposalService,
		private store: Store<AppState>
	) {}

	private getStoreValue(action, state: ProposalsState): Proposal {
		if (!_.has(state, "error") && !state.loading) {
			return null;
		}
		return _.find(
			_.get(state, `${StoreKeys.proposalStateKey}.proposalsWithDetails`, []),
			(p) => p.id === action.id
		);
	}
}
